import { FILTER_DRAWER_FOOTER_HEIGHT } from 'constants/styled.contants';
import styled, { css } from 'styled-components';

export const ContentAccordion = styled.span<{ hasMarginBottom: boolean }>`
  display: block;

  ${({ hasMarginBottom }) =>
    hasMarginBottom &&
    css`
      margin-bottom: ${FILTER_DRAWER_FOOTER_HEIGHT};
    `}

  p {
    padding-bottom: ${({ theme }) => theme.spacing.km4};
  }

  p::first-letter {
    text-transform: uppercase;
  }

  label {
    margin-left: ${({ theme }) => theme.spacing.km4};
  }

  div {
    padding-bottom: ${({ theme }) => theme.spacing.km4};
  }
`;
